jQuery(function($) {

  // Stick to top on scroll finder nav
  $(window).on('load resize scroll', function() {
    var finderNav = $('.finder__filter');
    var finderGrid = $('.finder__grid');
    if (finderGrid.length > 0) {
      var headerOuter = $('header').outerHeight();
      var scroll = $(document).scrollTop();
      var finderFilterHeight = $('.finder__filter').height();
      var limitTop = finderGrid.offset().top + finderGrid.outerHeight(true) - headerOuter;

      if (scroll >= limitTop) {
        var finderNavHeight = finderNav.outerHeight();
        finderNav.addClass('finder__filter--fixed');
        $('.filter').css('margin-top', finderNavHeight + 'px');
      } else {
        finderNav.removeClass('finder__filter--fixed');
        $('.filter').css('margin-top', '0px');
      }
    }
  });

  // Mobile nav filter dropdowns
  $('.finder__filter .nav__menu-item').click(function(e) {
    e.preventDefault();
    if (window.innerWidth < 1024) {
      $('.nav__menu-item .svgstore--dropdown-arrow').toggleClass('active');
      $('.nav__submenu', this).toggle();
    }
  });


  // Click filter image and scroll to filter nav
  $('.filter__img').click(function() {
    $('html, body').animate({
      scrollTop: $('.finder__filter').offset().top - $('header').outerHeight()},
      'slow');
  });


});